import React, { createContext, useContext, useState } from 'react';

// Create the SuccessFailureContext
const SuccessFailureContext = createContext();

// Create a custom hook to use the context
export const useSuccessFailure = () => {
  return useContext(SuccessFailureContext);
};

// SuccessFailureProvider component to provide context to the app
export const SuccessFailureProvider = ({ children }) => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isFailureModalOpen, setIsFailureModalOpen] = useState(false);
  const [message, setMessage] = useState('');  // Message to be displayed in the modal

  // Function to show the success modal with a message
  const showSuccessModal = (msg) => {
    setMessage(msg);
    setIsSuccessModalOpen(true);
  };

  // Function to show the failure modal with a message
  const showFailureModal = (msg) => {
    setMessage(msg);
    setIsFailureModalOpen(true);
  };

  // Function to hide the modals
  const hideModal = () => {
    setIsSuccessModalOpen(false);
    setIsFailureModalOpen(false);
  };

  return (
    <SuccessFailureContext.Provider
      value={{
        isSuccessModalOpen,
        isFailureModalOpen,
        message,
        showSuccessModal,
        showFailureModal,
        hideModal,
      }}
    >
      {children}
    </SuccessFailureContext.Provider>
  );
};
